import React from 'react';

import { ExportsModal } from '../components/ExportsModal';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useCreateExportMutation } from '../service/exports.api';

export const ExportsCreateContainer = () => {
    const [createExport, { isSuccess, isLoading, isError, error }] =
        useCreateExportMutation();

    useApiErrorNotification(isError, error);

    return (
        <ExportsModal
            isLoading={isLoading}
            isSuccess={isSuccess}
            createExport={createExport}
        />
    );
};
